'use client'
import useConsentManager from '@/src/shared/lib/hooks/useConsentManager'

/**
 * ConsentUpdate Component
 *
 * Bu component sadece useConsentManager hook'unu başlatır.
 * Tüm consent yönetimi logic'i hook içinde yapılır.
 */

const ConsentUpdate = () => {
  useConsentManager()

  return null
}

export default ConsentUpdate
